import { get, post, put, del } from "../request";

const PREFIX = "/contentAdmin/knowledgeBaseAdmin";

/** 分页查询知识库 */
export function getKnowledgeList(params) {
  return get(`${PREFIX}/list`, params);
}

/** 查询知识库树 */
export function getKnowledgeTree(params) {
  return get(`${PREFIX}/tree`, params);
}

/** 知识库详情 */
export function getKnowledgeDetail(knowledgeId) {
  return get(`${PREFIX}/${knowledgeId}`);
}

/** 新增知识库 */
export function addKnowledge(data) {
  return post(PREFIX, data);
}

/** 修改知识库 */
export function updateKnowledge(data) {
  return put(PREFIX, data);
}

/** 删除知识库及其子节点 */
export function deleteKnowledge(knowledgeIds) {
  return del(`${PREFIX}/${knowledgeIds}`);
}



// WEBPACK FOOTER //
// ./src/api/content/knowledge.js